/* eslint-disable @typescript-eslint/no-unused-vars */
import Button from "components/Buttons/ThemeButton";
import CloseIconButton from "../../lib/CloseIconButton";
import {
	Box,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Grid,
	Typography
} from "@mui/material";
import { StyledBox } from "../styled";
import { useState } from "react";
import { CrownIcon } from "utils/svgIcons";
import { Legalese } from "../lib/Legalese_SingleItem";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";

export const SingleItem = ({
	onClose,
	onClickBuy,
	hideRewardsDetails
}: {
	onClose: () => void;
	onClickBuy: (offerId: string) => void;
	hideRewardsDetails: boolean;
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const { dialogState } = useDialogModalRedux();
	const { offerId, itemDescription, itemPrice, itemImageUrl, data } =
		dialogState;

	const onClick = () => {
		setIsLoading(true);
		onClickBuy(offerId || "");
		setTimeout(() => {
			setIsLoading(false);
		}, 5000);
	};

	return (
		<>
			<DialogTitle
				sx={{
					p: !hideRewardsDetails ? "40px 25px" : "25px",
					backgroundSize: "contain",
					backgroundColor: !hideRewardsDetails ? "#FFFAF1" : "transparent",
					backgroundPosition: "center",
					overflow: "hidden"
				}}
			>
				<CloseIconButton onClose={onClose} />
				{!hideRewardsDetails && (
					<Grid
						container
						sx={{ flexWrap: "nowrap", lineHeight: 1 }}
						alignItems="center"
					>
						<Grid item>
							<StyledBox sx={{ mr: 2 }}>
								<img src={itemImageUrl} alt={itemDescription} />
							</StyledBox>
						</Grid>
						<Grid item>
							<Box>
								<strong style={{ fontSize: 20 }}>{itemDescription}</strong>
								<Typography fontSize={16}>
									<CrownIcon
										style={{
											marginRight: "6px",
											marginBottom: "-2px",
											width: "14px"
										}}
									/>
									{itemPrice?.toLocaleString("en-US")}
								</Typography>
							</Box>
						</Grid>
					</Grid>
				)}
			</DialogTitle>
			<DialogContent sx={{ pb: 0, alignContent: "center" }}>
				<DialogContentText sx={{ p: ".75rem 1rem" }}>
					<Typography
						variant={"h4"}
						component="strong"
						sx={{
							fontWeight: "bold",
							display: "block",
							textAlign: "center",
							lineHeight: 1,
							color: "#333333"
						}}
					>
						Confirm your purchase
					</Typography>
				</DialogContentText>
			</DialogContent>
			<DialogActions
				sx={{
					justifyContent: "center",
					flexDirection: "column",
					pb: 0,
					height: "160px"
				}}
			>
				<Legalese />
				{isLoading ? (
					<Button
						disabled
						sx={{
							pt: ".75rem",
							pb: ".75rem",
							mb: 1,
							width: "calc(100% - 3rem)"
						}}
					>
						processing...
					</Button>
				) : (
					<Button
						onClick={onClick}
						sx={{
							pt: ".75rem",
							pb: ".75rem",
							mb: 1,
							width: "calc(100% - 3rem)"
						}}
					>
						Buy
					</Button>
				)}
			</DialogActions>
		</>
	);
};
